/* eslint-disable @next/next/no-img-element */
import React from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../../organisms/CustomEmblaCarouselHome24';
import Styles from './Home24Canais.css';

function Home24Canais() {
  return (
    <section id="santander-canais">
      <ContainerHome24>
        <h3 className="headline-canais">Canais digitais</h3>
        <p className="sub-headline">
          Você consegue fazer tudo o que faria em uma agência Santander.
        </p>
      </ContainerHome24>

      <ContainerHome24>
        <CustomEmblaCarouselHome24 enableBullets enableMobileArrows detectBulletCount>
          {({ className }) => (
            <>
              <div className={`slide ${className}`}>
                <a
                  className="canais-card"
                  href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:canais-portal-do-cliente&int_campaign=acessar"
                  target="_blank"
                  rel="noopener"
                  id="canais-portal-do-cliente"
                >
                  <img
                    src="static/amp/shared/assets/ic_user.svg"
                    alt="Ícone de usuário"
                    layout="fixed"
                    height="32"
                    width="32"
                  />
                  <h3>Portal do cliente</h3>
                  <u>Acessar</u>
                </a>
              </div>

              <div className={`slide ${className}`}>
                <a className="canais-card" href="canais-de-atendimento.html" id="canais-whatsapp">
                  <img
                    src="static/amp/shared/assets/ic_wpp.svg"
                    alt="Ícone Whatsapp"
                    layout="fixed"
                    height="32"
                    width="32"
                  />
                  <h3 className="wpp-icon-wrapper">
                    WhatsApp
                    {/* <img
                      layout="fixed"
                      src="static/amp/shared/assets/verified-whatsapp.png"
                      alt="Ícone de verificado"
                      height="16"
                      width="16"
                    /> */}
                    <ins>11 4004-9090</ins>
                  </h3>
                  <u>Acessar</u>
                  <div className="qr-code">
                    <div>
                      <img
                        src="static/amp/shared/assets/qr_code_whatsapp_v2.png"
                        alt="Ícone QrCode Whatsapp"
                        layout="fixed"
                        height="74"
                        width="74"
                      />
                    </div>
                  </div>
                </a>
              </div>

              <div className={`slide ${className}`}>
                <a
                  className="canais-card"
                  href="https://santanderfinanciamentos.com.br/portalcliente/login"
                  target="_blank"
                  id="canais-aplicativo"
                >
                  <img
                    src="static/amp/shared/assets/ic_dealer_reseller.svg"
                    alt="Ícone Santander"
                    layout="fixed"
                    height="32"
                    width="32"
                  />
                  <h3>Portal de Renegociação</h3>
                  <u>Acessar</u>
                </a>
              </div>

              <div className={`slide ${className}`}>
                <a
                  href="https://abrasuaconta.santander.com.br/landing/?ori=SF&int_source=pagina-home-canais-abra-sua-conta&utm_source=cross-sell-financeira&utm_medium=portal-financeira-outrosprod&utm_campaign=cross-sell-financeira-portal-financeira-outrosprod&cp=94&sp=1"
                  target="_blank"
                  rel="noopener"
                  className="canais-card no-margin"
                  id="canais-abra-sua-conta"
                >
                  <img
                    src="static/amp/shared/assets/ic_account.svg"
                    alt="Ícone de cifrão"
                    layout="fixed"
                    height="32"
                    width="32"
                  />
                  <h3>Abra sua conta</h3>
                  <u>Acessar</u>
                </a>
              </div>
            </>
          )}
        </CustomEmblaCarouselHome24>
      </ContainerHome24>

      <style jsx>{Styles}</style>
    </section>
  );
}

export default Home24Canais;
